// extracted by mini-css-extract-plugin
export default {"login":"YlyA","signupButtonLabel":"KqST"};